import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import YandexMetrika from "./metrics/YandexMetrika";
import "./App.css";

import Home from "./pages/Home/Home";
import Profile from "./pages/Profile/Profile";
import Reservation from "./pages/Reservation/Reservation";

import Info from "./pages/Info/Info";
import Album from "./pages/Album/Album";
import Albums from "./pages/Album/Albums/Albums";

import Header from "./components/Header/Header";
import Menu from "./components/Menu/Menu";
import Loader from "./pages/Loader/Loader";
import BigScreen from "./pages/BigScreen/BigScreen";
import Residence from "./pages/Residence/Residence";

import axios from "./api/axios";

import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./features/userSlice";
import { fetchProducts } from "./features/productsSlice";
import { fetchHome } from "./features/homeSlice";
import Shop from "./pages/Shop/Shop";
import BackButtonHandler from "./components/BackButton/BackButton";

import tg from "./api/tg";
import Parking from "./pages/Parking/Parking";
import Rooms from "./pages/Rooms/Rooms";
import Room from "./pages/Rooms/Room/Room";
import SendSms from "./pages/SendSms/SendSms";
import Contacts from "./pages/Contacts/Contacts";
import Artefacts from "./pages/Artefacts/Artefacts";
import Artrfact from "./pages/Artefacts/Artefact/Artrfact";
import UnconfirmedBatches from "./pages/UnconfirmedBatches/UnconfirmedBatches";

import { useSwipeable } from "react-swipeable";
import { AnimatePresence, motion } from "framer-motion";
import SpecialOffer from "./pages/Reservation/SpecialOffer";

import reservImg from "./assets/img/reserv.webp";
import menuImg from "./assets/img/menu.png";
import homeImg from "./assets/img/home.webp";
import parkImg from "./assets/img/park.webp";
import keyImg from "./assets/img/key.webp";
import photoImg from "./assets/img/photo.webp";
import phoneImg from "./assets/img/phone.webp";
import smsImg from "./assets/img/sms.webp";
import artImg from "./assets/img/art.webp";
import discImg from "./assets/img/disc.webp";
import ketImg from "./assets/img/ket.webp";
import blackTextur from "./assets/img/textur_black.webp";

import veranda1 from "./assets/img/Stories/Veranda/1.jpg";
import parking1 from "./assets/img/Stories/Parking/1.jpg";
import kalyan1 from "./assets/img/Stories/Kalyan-Lunch/1.jpg";
import vinil1 from "./assets/img/Stories/Vynil-Room/1.jpg";
import radiola1 from "./assets/img/Stories/Radiola-Room/1.jpg";
import studio1 from "./assets/img/Stories/Studio-54/1.jpg";
// import ReservationPlaceholder from "./pages/Stub/Stub";

const PAGE_TRANSITION_DURATION = 0.32;


// 1.0
// const pageVariants = {
//   initial: (direction) => ({
//     x: direction === "back" ? "-18%" : "100%",
//     scale: direction === "back" ? 0.985 : 1,
//     opacity: direction === "none" ? 1 : 0.96,
//   }),
//   animate: {
//     x: 0,
//     scale: 1,
//     opacity: 1,
//   },
//   exit: (direction) => ({
//     x: direction === "back" ? "100%" : "-20%",
//     scale: direction === "back" ? 1 : 0.97,
//     opacity: 0.95,
//   }),
// };

const pageVariants = {
  initial: (direction) => ({
    x: direction === "back" ? "-18%" : "100%",
    opacity: direction === "none" ? 1 : 0.96,
  }),
  animate: { x: 0, opacity: 1 },
  exit: (direction) => ({
    x: direction === "back" ? "100%" : "-20%",
    opacity: 0.95,
  }),
};

//////////////////////////

const pageTransition = {
  x: {
    type: "tween",
    duration: PAGE_TRANSITION_DURATION,
    ease: [0.25, 0.1, 0.25, 1],
  },
  scale: {
    type: "tween",
    duration: PAGE_TRANSITION_DURATION,
    ease: [0.25, 0.1, 0.25, 1],
  },
  opacity: {
    type: "tween",
    duration: PAGE_TRANSITION_DURATION * 0.9,
    ease: [0.25, 0.1, 0.25, 1],
  },
};

const preloadImage = (src) =>
  new Promise((resolve) => {
    if (!src) return resolve();
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = src;
  });

const preloadStaticImages = async () => {
  const staticImages = [
    reservImg,
    menuImg,
    homeImg,
    parkImg,
    keyImg,
    photoImg,
    phoneImg,
    smsImg,
    artImg,
    discImg,
    ketImg,
    blackTextur,
    veranda1,
    parking1,
    kalyan1,
    vinil1,
    radiola1,
    studio1,
  ];

  await Promise.all(staticImages.map((img) => preloadImage(img)));
};

export default function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  const [navigationHistory, setNavigationHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(0);
  const [swipeDirection, setSwipeDirection] = useState("none");
  const isNavigatingRef = useRef(false);
  const isInitializedRef = useRef(false);

  const realTgData = tg?.initDataUnsafe?.user;

  const devUser = {
    id: 2038669608,
    username: "devuser",
    first_name: "",
    last_name: "",
    language_code: "en",
  };

  const isDev = !realTgData;
  const user = isDev ? devUser : tg.initDataUnsafe.user;
  const auth_date = isDev ? Date.now() : tg.initDataUnsafe.auth_date;
  const hash = isDev ? "devhash" : tg.initDataUnsafe.hash;

  const dispatch = useDispatch();
  const homeLoading = useSelector((s) => s.home.loading);
  const [showLoader, setShowLoader] = useState(true);
  const [isInitializing, setIsInitializing] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitializedRef.current) {
      setNavigationHistory([location.pathname]);
      setHistoryIndex(0);
      isInitializedRef.current = true;
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isInitializedRef.current) return;

    if (isNavigatingRef.current) {
      isNavigatingRef.current = false;
      return;
    }

    const currentPath = location.pathname;

    setNavigationHistory((prevHistory) => {
      if (prevHistory[prevHistory.length - 1] === currentPath) {
        return prevHistory;
      }

      const newHistory = [...prevHistory];

      if (historyIndex < prevHistory.length - 1) {
        newHistory.splice(historyIndex + 1);
      }

      newHistory.push(currentPath);

      setHistoryIndex(newHistory.length - 1);

      return newHistory;
    });
  }, [location.pathname, historyIndex]);

  useEffect(() => {
    if (isInitializedRef.current && !isNavigatingRef.current) {
      setHistoryIndex(navigationHistory.length - 1);
    }
  }, [navigationHistory.length]);

  useEffect(() => {
    tg.ready();
    tg.expand();

    const isMobileFullscreen = /Android|iPhone|iPad/i.test(navigator.userAgent);

    if (isMobileFullscreen) {
      tg.requestFullscreen();
    }

    tg.disableVerticalSwipes();
    tg.setHeaderColor("#FFFFFF");

    const onResize = () => setIsMobile(window.innerWidth <= 500);
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const userData = {
          user,
          auth_date,
          hash,
        };

        await axios.post("/api/check/user", userData);
        const { data } = await axios.get(`/api/user/${user.id}`);
        dispatch(setUser(data));

        await Promise.all([
          dispatch(fetchProducts()).unwrap(),
          dispatch(fetchHome()).unwrap(),
          preloadStaticImages(),
        ]);
      } catch (err) {
        console.error("Ошибка получения пользователя:", err);
      } finally {
        setIsInitializing(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!homeLoading && !isInitializing && showLoader) {
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [homeLoading, isInitializing, showLoader]);

  const handleSwipe = (direction) => {
    if (!isInitializedRef.current || navigationHistory.length === 0) {
      return;
    }

    if (direction === "right") {
      if (historyIndex > 0) {
        isNavigatingRef.current = true;
        setSwipeDirection("back");
        const newIndex = historyIndex - 1;
        setHistoryIndex(newIndex);
        navigate(navigationHistory[newIndex]);
      }
    } else if (direction === "left") {
      if (historyIndex < navigationHistory.length - 1) {
        isNavigatingRef.current = true;
        setSwipeDirection("forward");
        const newIndex = historyIndex + 1;
        setHistoryIndex(newIndex);
        navigate(navigationHistory[newIndex]);
      }
    }
  };

  const handlers = useSwipeable(
    location.pathname === "/"
      ? {}
      : {
          onSwipedLeft: () => handleSwipe("left"),
          onSwipedRight: () => handleSwipe("right"),
          trackTouch: true,
          delta: 5,
          swipeDuration: 250,
          velocity: 0.05,
          trackMouse: false,
        }
  );

  if (!isMobile) return <BigScreen />;

  const appLoading = isInitializing || homeLoading || showLoader;

  // if (appLoading) {
  //   return (
  //     <div className="global-loader-overlay">
  //       <Loader />
  //     </div>
  //   );
  // }

  return (
    <>
      <YandexMetrika />

      {!appLoading && (
        <>
          <Header />
          <BackButtonHandler />
          <div {...handlers} className="swipe-container">
            <AnimatePresence mode="sync" initial={false}>
              <motion.div
                key={location.pathname}
                custom={swipeDirection}
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={pageTransition}
                className="route-wrapper"
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  willChange: "transform, opacity",
                }}
                onAnimationComplete={() => setSwipeDirection("none")}
              >
                <div style={{ paddingTop: "70px" }}>
                  <Routes location={location}>
                    <Route path="/" element={<Home />} />

                    <Route path="/reservation" element={<Reservation />} />
                    {/* <Route path="/reservation" element={<ReservationPlaceholder/>}/> */}

                    <Route path="/specialoffer" element={<SpecialOffer />} />
                    <Route path="/info" element={<Info />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/residence" element={<Residence />} />
                    <Route path="/parking" element={<Parking />} />
                    <Route path="/send-sms" element={<SendSms />} />
                    <Route path="/contacts" element={<Contacts />} />
                    <Route
                      path="/unconfirmed-batches"
                      element={<UnconfirmedBatches />}
                    />

                    <Route path="/albums" element={<Albums />} />
                    <Route path="/album/:id" element={<Album />} />

                    <Route path="/rooms" element={<Rooms />} />
                    <Route path="/rooms/:id" element={<Room />} />

                    <Route path="/artefacts" element={<Artefacts />} />
                    <Route path="/artefacts/:id" element={<Artrfact />} />
                  </Routes>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <Menu />
        </>
      )}

      {appLoading && (
        <div className="global-loader-overlay">
          <Loader />
        </div>
      )}

      <style jsx="true">{`
        .swipe-container {
          position: absolute;
          top: var(--tg-app-top);
          bottom: 0;
          left: 0;
          right: 0;
          overflow: hidden;
          touch-action: pan-y;
          transform: translate3d(0, 0, 0);
          background-color: #ffffff;
        }

        .route-wrapper {
          min-height: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          background-color: #ffffff;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior: contain;
          transform: translateZ(0);
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
        }
      `}</style>
    </>
  );
}
